import { z } from 'zod';

export const domainSchema = z.object({
  domain: z
    .string()
    .min(1, 'Domain is required')
    .regex(/^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63})+$/, 'Enter a valid domain (e.g. acme.com)'),
  catchAllEnabled: z.boolean().default(false),
  dnsMode: z.enum(['managed', 'external']).default('external'),
});
export type DomainFormValues = z.infer<typeof domainSchema>;

/** Managed-DNS record editor (mirrors the backend CreateDnsRecordDto limits). */
const PRIORITY_TYPES = ['MX', 'SRV'];
export const dnsRecordSchema = z
  .object({
    type: z.enum(['A', 'AAAA', 'CNAME', 'MX', 'TXT', 'SRV', 'CAA']),
    host: z.string().min(1, 'Host is required').max(253, 'Too long'),
    value: z.string().min(1, 'Value is required').max(2048, 'Too long'),
    priority: z.coerce.number().int().min(0).max(65535).optional(),
    ttl: z.coerce.number().int('TTL must be a whole number').min(60, 'Min 60s').max(604800, 'Max 7 days').default(3600),
  })
  .refine((v) => !PRIORITY_TYPES.includes(v.type) || v.priority != null, {
    message: 'Priority is required for MX and SRV records',
    path: ['priority'],
  });
export type DnsRecordFormValues = z.infer<typeof dnsRecordSchema>;
